import { __decorate } from "tslib";
import { Component, Vue } from 'vue-property-decorator';
import { AppModule } from '@blade/common/store/app';
import LangSelect from './lang-select.vue';
import systemManagement from './system-management.vue';
import { EventBus, EventKeys } from '@blade/common';
import MsgAlarm from '@blade-sxp/monitor/components/msg/alarm.vue';
import { AccountModule } from '@blade-sxp/account/store/account';
import authItem from '@blade/common/components/auth/auth-item.vue';
import { LoginModule } from '@blade/common/store/login';
let default_1 = class extends Vue {
    timer;
    wsUrl = '';
    msgList = [];
    userName = '';
    avatar = '';
    MAX_UNREAD_NUMBER = 99;
    logo = '';
    get device() {
        return AppModule.device.toString();
    }
    setting() {
        this.$router.push(`/personal/personal`);
    }
    handleLogout() {
        window.sessionStorage.setItem('isAuthenticated', 'false');
        LoginModule.updatePassType(true);
        LoginModule.updatePermission([]);
        EventBus.$emit(EventKeys.Logout);
        localStorage.removeItem('language');
        // const redirectUrl = `${window.location.protocol}//${window.location.host}/authn`;
        // window.location.replace(redirectUrl);
        // this.$router.replace(redirectUrl);
        this.$keycloak.logout({
            redirectUri: window.location.origin,
        });
        // location.reload();
    }
    async mounted() {
        try {
            this.userName = await AccountModule.getUserName();
            this.avatar = await AccountModule.getAvatar();
            const newLogo = LoginModule.logoConfig.systemName;
            const defaultLogoUrl = LoginModule.logoConfig.defaultLogoUrl;
            const menuShrinkageLogoUrl = LoginModule.logoConfig.menuShrinkageLogoUrl;
            if (newLogo !== '' || defaultLogoUrl !== '' || menuShrinkageLogoUrl !== '') {
                this.logo = newLogo;
            }
        }
        catch (e) { }
    }
};
default_1 = __decorate([
    Component({
        name: 'Navbar',
        components: {
            LangSelect,
            MsgAlarm,
            systemManagement,
            authItem,
        },
        i18n: {
            messages: {
                'en-us': {
                    logout: 'Log Out',
                    personalCenter: 'Personal Center',
                    name: 'Name',
                    position: 'position',
                    regionalInvasion: 'Regional invasion',
                    faceControlRatio: 'Facial Matched Result',
                    overflowOfPeople: 'Overflow of people',
                    crowded: 'Crowded',
                    crowdgathering: 'Crowd gathering',
                    crowdSpreadOut: 'Crowd spread out',
                    crowdCountercurrent: 'Crowd countercurrent',
                    crowdRetention: 'Crowd retention',
                    distanceTooClose: 'Social distance too close',
                    missionName: 'Task Name',
                    taskType: 'Task type',
                    deviceName: 'Device Name',
                    triggerTime: 'Created Time',
                    threshold: 'Threshold',
                    portraitLibrary: 'Portrait Library',
                    idPicture: 'ID Photo',
                    liveAvatar: 'Live Avatar',
                    numberThreshold: 'Threshold Number of People',
                    detentionTimeThreshold: 'Loitering Time Threshold',
                    currentNumber: 'Current number',
                    LengthOfStay: 'Length of stay',
                    people: 'people',
                    direction: 'Statistical direction',
                    statisticalTime: 'Statistical time',
                    overrunThreshold: 'Overrun threshold',
                    statistics: 'Statistics',
                    crossLine: 'Cross line direction indicator',
                    area: 'Area',
                    numberOfpeople: 'Number of people',
                    crowdDensity: 'Crowd density',
                    distanceThreshold: 'Distance threshold',
                    durationThreshold: 'Duration threshold',
                    distance: 'Distance',
                    duration: 'duration',
                    alarmMethod: 'Alarm method',
                    numberOfUpstream: 'Number of upstream',
                    socialDistance: 'Social distance threshold',
                    positiveDirection: 'Positive direction indicator',
                    heatMap: 'Heatmap',
                },
                zh: {
                    logout: '登出',
                    personalCenter: '个人中心',
                    name: '姓名',
                    position: '位置',
                    regionalInvasion: '区域入侵',
                    faceControlRatio: '人脸布控比中',
                    overflowOfPeople: '人流量超限',
                    crowded: '人群过密',
                    crowdgathering: '人群聚集',
                    crowdSpreadOut: '人群分散',
                    crowdCountercurrent: '人群逆流',
                    crowdRetention: '人群滞留',
                    distanceTooClose: '社交距离过近',
                    missionName: '任务名称',
                    taskType: '任务类型',
                    deviceName: '设备名称',
                    triggerTime: '触发时间',
                    threshold: '阈值',
                    portraitLibrary: '人像库',
                    idPicture: '证件头像',
                    liveAvatar: '现场头像',
                    numberThreshold: '人数阈值',
                    detentionTimeThreshold: '滞留时长阈值',
                    currentNumber: '当前人数',
                    LengthOfStay: '滞留时长',
                    people: '人',
                    direction: '统计方向',
                    statisticalTime: '统计时长',
                    overrunThreshold: '超限阈值',
                    statistics: '统计人数',
                    crossLine: '跨线方向标识',
                    area: '区域面积',
                    numberOfpeople: '人数',
                    crowdDensity: '人群密度',
                    distanceThreshold: '距离阈值',
                    durationThreshold: '时长阈值',
                    distance: '距离',
                    duration: '时长',
                    alarmMethod: '告警方式',
                    numberOfUpstream: '逆流人数',
                    socialDistance: '社交距离阈值',
                    positiveDirection: '正方向标识',
                    heatMap: '热力图',
                },
            },
        },
    })
], default_1);
export default default_1;
